<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/blue-code.jpg')" >
      </parallax>
      <div class="content-center">
        <div class="container">
          <img class="n-logo" src="img/stormhaven-logo.small.png" alt="" />
          <h1 class="title">FX Artist</h1>
        </div>
      </div>
    </div>
    <div class="section">
        <div class="container">
            <div class="row">
                <p>As FX Artist on the Embers Adrift MMORPG, you’ll be creating explosions, spell casts, ambient world effects, beyond. You will be the bridge between art and design communicating gameplay ideas to the player all while creating a compelling visual storytelling experience.</p>
                <p>This is a work-for-hire, contract position. We fully support a remote work force, and encourage contractors from anywhere in the world to apply. We are an equal opportunity employer.</p>
            </div>
            <div class="row">
                <div style="font-weight: bold;">Your Background</div>
            </div>
            <div class="row">
                <ul>
                    <li>Experience developing particle systems and geometry based visual effects</li>
                    <li>Background in animation with an eye for timing is a plus</li>
                    <li>Understand real-time game development needs</li>
                    <li>Self-driven, passionate, creative problem solver, and a great team first attitude</li>
                    <li>Ability to explore a wide variety of ideas that push the Embers Adrift style</li>
                </ul>
            </div>
            <div class="row">
                <div style="font-weight: bold;">Day to Day Tasks</div>
            </div>
            <div class="row">
                <ul>
                    <li>Create spells, creature attacks, explosions and more FX animations in the Embers Adrift style</li>
                    <li>Strong hand painted texturing skill that fits within the larger world</li>
                    <li>Ability to prototype and create block-out FX</li>
                    <li>Enthusiasm for working closely with other Artists</li>
                    <li>Communicate with Production, Design, and other departments</li>
                </ul>
            </div>
            <div class="row">
                <div style="font-weight: bold;">Requirements for Applying</div>
            </div>
            <div class="row">
                <ul>
                    <li>Resume</li>
                    <li>Demo Reel Link</li>
                    <li>Cover letter which should include:
                        <ul>
                            <li>Why you are interested in working at Stormhaven Studios, LLC</li>
                            <li>What games you are currently playing</li>
                        </ul>
                    </li>
                    <li>Portfolio – Only digital applications will be accepted such as a website, blog, or online album.  Physical media will not be accepted.</li>
                    <li>A paid test may be requested during the interview process</li>
                </ul>
            </div>
            <div class="row">
                <p>Stormhaven Studios, LLC is a global company committed to growing our contractors and employees along with the business. We’ve worked hard to foster an intensely collaborative and creative environment with a diverse and inclusive culture of people from around the world, with training and opportunity for professional growth. Our people are everything to us. We are dedicated to creating the most epic entertainment experiences…ever. We look forward to having you on the team!</p>
            </div>
            <div class="row" style="margin-top: 24px;">
                <h2><a href="mailto:jobs@stormhavenstudios.com">Apply Now!</a></h2>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'fxartist',
  bodyClass: 'landing-page'
};
</script>
<style></style>
